import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#1890ff',
  layout: 'mix',
  splitMenus: true, // 启用菜单自动切分，一级菜单放顶部
  siderMenuType: 'group', // 侧边栏菜单使用分组模式
  contentWidth: 'Fluid',
  fixedHeader: true, // 固定顶部导航
  fixSiderbar: true,
  colorWeak: false,
  title: 'LiteInn',
  pwa: true,
  logo: 'https://ai.liteinn.com/logo.svg',
  iconfontUrl: '',
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    // https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
    header: {
      // 顶部菜单选中颜色
      colorTextMenuSelected: '#1890ff',
      // 顶部菜单选中背景色
      colorBgMenuItemSelected: 'rgba(24, 144, 255, 0.1)',
    },
    sider: {
      // 侧边菜单选中颜色
      colorTextMenuSelected: '#1890ff',
      // 侧边菜单选中背景色
      colorBgMenuItemSelected: 'rgba(24, 144, 255, 0.15)',
    },
    pageContainer: {
      // PageContainer 左右内边距（房态页面不使用 PageContainer，无需单独配置）
      paddingInlinePageContainerContent: 16,
      // PageContainer 上下内边距
      paddingBlockPageContainerContent: 16,
    },
  },
};

export default Settings;
